import React from "react";
import VideoCard from "./VideoCard";

const CategorySection = ({ category, videos, startIndex = 0, onVideoClick }) => {
  // Split videos into rows of 3
  const rows = [];
  for (let i = 0; i < videos.length; i += 3) {
    rows.push(videos.slice(i, i + 3));
  }

  return (
    <div className="flex flex-col gap-6 items-start w-full">
      {/* Category Title */}
      <div className="flex flex-col items-center justify-center px-2">
        <h2
          className="text-2xl font-medium leading-7 tracking-[-0.24px] text-[#0E49B5]"
          style={{ fontFamily: "Satoshi, sans-serif" }}
        >
          {category.title}
        </h2>
      </div>

      {/* Video Cards Grid */}
      <div className="flex flex-col gap-6 w-full">
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className="flex gap-6 items-start flex-wrap">
            {row.map((video, videoIndex) => (
              <VideoCard
                key={video.id}
                video={video}
                index={startIndex + rowIndex * 3 + videoIndex}
                onVideoClick={onVideoClick}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategorySection;
